/* global jQuery COMPONENTS */

COMPONENTS.ComponentMenu = (function ($) {
  function ComponentMenu () {
    this.$component = $('[data-ecs-component="component-menu"]')
    this.$component.notificationBar = $('[data-ecs-component="component-notificationbar"]')
    this.$component.header = $('[data-ecs-component="component-menu"]')
    this.$component.menuDrawer = this.$component.find('[data-drawer-wrap]')
    this.$component.menuButtons = this.$component.find('[data-control-drawer="main-menu"]')
    const viewportLaptop = window.matchMedia('(min-width: 1024px)')

    this.setMenuOpenHeight = function () {
      const component = this
      var $drawerHeight = (window.innerHeight - this.$component.outerHeight() - this.$component.notificationBar.outerHeight()) + 'px'

      component.$component.menuDrawer.css('max-height', $drawerHeight)
    }

    this.setMenuTransparentTop = function () {
      const component = this
      var headerHeight = component.$component.header.outerHeight()

      if ($('body').hasClass('ecs_transparent_header')) {
        component.$component.header.css('margin-bottom', '-' + headerHeight + 'px')
      }
    }

    this.toggleMenu = function () {
      const component = this

      if (component.$component.menuDrawer.attr('data-ecs-state') == 'closed') { // menu is closed, open the menu
        $('html, body').animate({ scrollTop: 0 }, 'slow') // scroll to top of page
        component.$component.menuDrawer.attr('data-ecs-state', 'open') // toggle menu open state
        this.setMenuOpenHeight()
      } else { // menu is open, close the menu
        component.$component.menuDrawer.attr('data-ecs-state', 'closed') // toggle menu open state
        component.$component.menuDrawer.css('max-height', '0px')
      }

      component.$component.menuDrawer.toggleClass('ecs_open') // toggle menu class
      $('body').toggleClass('ecs_menu_open') // toggle menu class
      $('html').toggleClass('ecs_prevent_scroll') // lock the user into the menu
    }

    ComponentMenu.prototype.init = function () {
      const component = this
      const viewportLaptop = window.matchMedia('(min-width: 1024px)')

      component.setMenuTransparentTop()

      // If screen rotates, reset the menu states
      $(window).on('resize orientationchange', function () {
        component.setMenuOpenHeight()
        component.setMenuTransparentTop()
      })

      // Drawer buttons/controls on click
      component.$component.menuButtons.click(function () {
        const viewportLaptop = window.matchMedia('(min-width: 1024px)')
        if (!viewportLaptop.matches) {
          component.toggleMenu()
        }
      })
    }
  }

  return ComponentMenu
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentMenu = new COMPONENTS.ComponentMenu()
  COMPONENTS.componentMenu.init()
})
